// extracted by mini-css-extract-plugin
module.exports = {"story":"s-module--story--FO7LH","storyLayout":"s-module--storyLayout--nXMzD"};